"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.classicConfiguration = exports.classic = void 0;
const Defaults = __importStar(require("./commonBlockConfigs"));
const types_1 = require("../types");
const commonNumberings_1 = require("./commonNumberings");
const commonMargins_1 = require("./commonMargins");
exports.classic = {
    slug: Object.freeze({
        ...Defaults.CLASSIC_BASE,
        alignment: types_1.ZAlignmentEnum.enum.right,
        uppercase: true,
        underline: true,
    }),
    bracket: Object.freeze({
        ...Defaults.CLASSIC_BASE,
        color: '#cd3c8c',
    }),
    character: Object.freeze({
        ...Defaults.CLASSIC_BASE,
        uppercase: true,
        dualDialogOverrides: Defaults.DUAL_DIALOGUE_CHARACTER_OVERRIDE,
    }),
    parenthetical: Object.freeze({
        ...Defaults.CLASSIC_BASE,
        dualDialogOverrides: Defaults.DUAL_DIALOGUE_PARENTHETICAL_OVERRIDE,
    }),
    dialogue: Object.freeze({
        ...Defaults.CLASSIC_BASE,
        dualDialogOverrides: Defaults.DUAL_DIALOGUE_DIALOGUE_OVERRIDE,
    }),
    new_act: Object.freeze({
        ...Defaults.CLASSIC_BASE,
        uppercase: true,
        underline: true,
    }),
    // these aren't meant to appear classic, but this is what happens if they do
    action: Defaults.ACTION,
    general: Object.freeze({
        ...Defaults.CLASSIC_BASE,
        color: '#ad611f',
    }),
    end_of_act: Defaults.END_OF_ACT,
    sceneHeading: Defaults.SCENE_HEADING,
    transition: Defaults.TRANSITION,
    dual_dialogue: Defaults.DUAL_DIALOGUE,
    dual_dialogue_column: Defaults.DUAL_DIALOGUE_COLUMN,
};
exports.classicConfiguration = {
    blocks: exports.classic,
    numbering: commonNumberings_1.DEFAULT_NUMBERING,
    margins: {
        topRight: commonMargins_1.PAGE_DOT,
    },
};
